import React, { useState, useRef } from 'react';
import './AppointmentForm.css';

function AppointmentForm() {
  const [showSuccess, setShowSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const formRef = useRef(null);

  const today = new Date().toISOString().split('T')[0];

  const handleSubmit = () => {
    setLoading(true);
    setShowSuccess(false);

    setTimeout(() => {
      setShowSuccess(true);
      setLoading(false);
    }, 1200);

    setTimeout(() => setShowSuccess(false), 5000);

    setTimeout(() => {
      if (formRef.current) {
        formRef.current.reset();
      }
    }, 1500);
  };

  // Prevent non-numeric input for phone
  const handlePhoneInput = (e) => {
    e.target.value = e.target.value.replace(/[^0-9]/g, '');
  };

  return (
    <div id="appointment" className="appointment-form-wrapper">
      <form
        ref={formRef}
        action="https://script.google.com/macros/s/AKfycby23pCLznfYdMm5OV12w1KAfStoa6YiwDAV4Tp5KgxTk6lcISEZcVATtltMzwsHc6Feqg/exec"
        method="POST"
        target="hidden_iframe"
        onSubmit={handleSubmit}
        className="appointment-form-vertical"
        autoComplete="off"
      >
        <h3>Book Your Appointment</h3>

        {showSuccess && (
          <div className="success-message" role="alert">
            ✔ Appointment submitted successfully!
          </div>
        )}
        {loading && (
          <div className="loading-message">
            Submitting...
          </div>
        )}

        <label htmlFor="name">Full Name</label>
        <input id="name" name="name" placeholder="Full Name" required aria-label="Full Name" />

        <label htmlFor="phone">Phone Number</label>
        <input
          id="phone"
          name="phone"
          placeholder="Phone Number"
          required
          maxLength={15}
          inputMode="numeric"
          pattern="[0-9]*"
          aria-label="Phone Number"
          onInput={handlePhoneInput}
        />

        <label htmlFor="date">Date</label>
        <input
          id="date"
          name="date"
          type="date"
          required
          min={today}
          aria-label="Appointment Date"
        />

        <label htmlFor="time">Time</label>
        <input id="time" name="time" type="time" required aria-label="Appointment Time" />

        <label htmlFor="service">Service</label>
        <select id="service" name="service" required aria-label="Service">
          <option value="">Select a Service</option>
          <option value="Smile Designing">Smile Designing</option>
          <option value="Root Canal">Root Canal</option>
          <option value="Teeth Whitening">Teeth Whitening</option>
          <option value="Braces / Aligners">Braces / Aligners</option>
          <option value="Cleaning & Polishing">Cleaning & Polishing</option>
          <option value="Other">Other</option>
        </select>

        <button type="submit" disabled={loading}>
          {loading ? "Submitting..." : "Confirm Appointment"}
        </button>

        <iframe
          name="hidden_iframe"
          title="Hidden appointment submission frame"
          style={{ display: 'none' }}
        ></iframe>
      </form>
    </div>
  );
}

export default AppointmentForm;